import type { AxiosResponse } from 'axios';
import { DEVELOPMENT, PRODUCTION, TEST, TEST_E2E } from './constants';

export type MetaResponse = {
    total?: number;
    page?: number;
    offset?: number;
    totalPages?: number;
    limit?: number;
};
export type ApiStandardResponse<T> = {
    meta: MetaResponse;
    data: T;
};

export type NodeEnvironmentType = typeof PRODUCTION | typeof DEVELOPMENT | typeof TEST | typeof TEST_E2E;

export type AxiosPromiseFn<T> = () => Promise<AxiosResponse<ApiStandardResponse<T>>>;

export type LocaleType = 'en' | 'es';

export type MobileOS = 'Android' | 'iOS';
